import { z } from 'zod';

// there is another schema used in the place where this endpoint is called
// due to snake_case vs camelCase conversion
/**
 * @noSchema
 */
export type ReportSummaryPayload = {
  current: {
    display: string;
    visualization_settings: unknown;
    dataset_query: unknown;
    description?: string;
    name?: string;
  };
};

export const reportSummary = (payload: ReportSummaryPayload) => {
  return {
    endpoint: `/internal/metabase/report_summary`,
    method: 'POST',
    responseSchema: z.unknown(),
    payload,
    payloadSchema: z.unknown(),
  } as const;
};
